import { initials } from '../../lib/staff-display.ts';
import { cn } from '../../lib/utils.ts';

/**
 * Avatar mit Initialen (Ticket 1.284 Nacharbeit): Kreis in der Größe des Icon-Kreises (`icon-circle`, 38 px) auf der
 * Akzent-Fläche (`brand-tile`), Initialen `text-caption`/500. Rein dekorativ – der Name steht immer daneben.
 */
export function Avatar({ name, className }: { name: string; className?: string }) {
  return (
    <span aria-hidden data-avatar="" className={cn('grid size-icon-circle flex-none place-items-center rounded-full bg-brand-tile text-caption font-medium text-brand-tile-fg', className)}>
      {initials(name)}
    </span>
  );
}
